import React, { useState, useEffect, useRef } from 'react';
import styles from "./experience.module.scss"
import useMediaQuery from '@mui/material/useMediaQuery';

import GraduationIcon from "@mui/icons-material/School";

import WorkIcon from '@mui/icons-material/WorkOutline';

import {
    TimelineConnector,
    TimelineContent,
    TimelineItem,
    TimelineOppositeContent,
    TimelineSeparator,
    Timeline,
    timelineContentClasses
} from "@mui/lab";
import ExperienceCard from '../experience_card/experience_card';


const Experience = () => {
    const [typedText, setTypedText] = useState('');
    const fullText = 'Education and Experience.';
    const sectionRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    let index = 0;
                    setTypedText('');
                    const typingInterval = setInterval(() => {
                        if (index < fullText.length) {
                            setTypedText(fullText.slice(0, index + 1));
                            index++;
                        } else {
                            clearInterval(typingInterval);
                        }
                    }, 150);

                    return () => clearInterval(typingInterval);
                }
            },
            { threshold: 0.1 }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => {
            if (sectionRef.current) {
                observer.unobserve(sectionRef.current);
            }
        };
    }, []);

    const matches = useMediaQuery('(min-width:600px)');
    const experienceData = [
        {
            timeline: "2025 - 2025",
            type: "Work",
            heading: "Software Engineer Intern",
            location: "BotStacks, California",
            summary: [
                "Improved chatbot usability by fixing auto-scroll, attachment handling, and input alignment issues using React and TypeScript, reducing UI friction and smoothing conversations.",

                "Enabled instant onboarding in Framer with URL input, stepwise progress, and preview chat, letting new users try the product without signing up.",

                "Increased trust in AI responses by preventing fake links, verifying allowed domains, and leveraging Python, LLMs, and Pinecone to ensure all shared links were accurate and clickable.",

                "Optimized backend API performance, reducing latency from ~25s to ~12s through query optimization.",
            ]
        },
        {
            timeline: "2025 - 2025",
            type: "Work",
            heading: "Software Engineer Intern",
            location: "Aeropay, Chicago",
            summary: [

                "Implemented a Python tool to convert AWS Step Function definitions into auto-generated flowcharts and documentation using Jinja2, Mermaid, and YAML parsing.",

                "Built a responsive UI using JavaScript, HTML, and CSS to improve navigation and developer experience.",

                "Developed a static API documentation site using Swagger, enhancing clarity and cross-team integration.",

                "Scoped and analyzed potential webhook retry mechanisms using Amazon SNS, SQS, and Lambda; evaluated how retry logic could be integrated into the existing system. Also wrote a Python script to extract error codes for automated debugging.",

                "Took initiative to resolve multiple bugs from sprint tickets in ClickUp, improving system stability and internal workflows."
            ]
        },
        {
            timeline: "2023 - 2025",
            type: "School",
            heading: "Masters in Computer Science",
            location: "Illinois Institute of Technology, Chicago",
            summary: [

                "Graduated with a Master’s in Computer Science from Illinois Institute of Technology with a GPA of 3.5/4, I immersed myself in a dynamic curriculum designed to build both depth and versatility in the tech landscape.",

                "My journey spanned key areas like Machine Learning, Big Data Technologies, and Data Preparation, giving me hands-on experience in extracting insights and solving real-world problems through data-driven approaches.",

                "Courses like Software Project Management and Information Security sharpened my ability to plan, secure, and execute technical projects efficiently, while subjects such as Mobile App Development and Advanced Databases broadened my full-stack development capabilities.",

                "With a strong foundation in both theory and applied skills, from designing scalable systems to writing secure and performant code, I’m excited to contribute to cutting-edge innovation and make a lasting impact in the software industry.",
            ]
        }, {
            timeline: "2023 - 2023",
            type: "Work",
            heading: "Software Developer",
            location: "Kirabiz, Pune, India",
            summary: [
                "As a Software Developer at Kirabiz, I built impactful full-stack solutions that elevated the user experience and drove measurable growth across e-commerce platforms.",

                "I enhanced product discoverability and boosted engagement by implementing interactive demos, intelligent recommendations, and verified review systems using React, Node.js, MongoDB, Firebase, and Python.",

                "My contributions helped increase user engagement by 20% and conversion rates by 15% on a Toys & Games platform, and improved customer retention by 18% on a Books & Stationery site through clean UI and smart search capabilities.",

                "I thrived in cross-functional collaboration, translating user insights and product goals into scalable, intuitive features that made the digital shopping experience smoother and more personalized."
            ]

        }, {
            timeline: "2020 - 2023",
            type: "School",
            heading: "Bachelor of Engineering in Computer Engineering",
            location: "Universal College of engineering, Mumbai, India",
            summary: [
                "During my Bachelor of Engineering in Computer Engineering at Universal College of Engineering, Mumbai, India, I immersed myself in a rigorous curriculum aimed at building a strong foundation in computer science.",
                "My coursework encompassed key subjects such as data structures, object-oriented programming with Java, database management systems, and the analysis of algorithms.",
                "Additionally, I delved into Python programming, software engineering principles, computer networks, and artificial intelligence.",
                "This comprehensive education equipped me with a solid understanding of core concepts and methodologies in computer engineering, preparing me for a successful career in the dynamic and ever-evolving field of technology."

            ]
        }, {
            timeline: "2022 - 2022",
            type: "Work",
            heading: "Web Developer (Pro Bono)",
            location: "Freelance, Mumbai, India",
            summary: [
                "Digitized and centralized student record-keeping for former school, reducing paperwork by ~75% and making records accessible in minutes instead of hours.",
                "Built a School Records Management System using PHP, MySQL, and Bootstrap for easy use by non-technical staff.",
                "Implemented role-based authentication, password hashing, and input validation to protect student data.",
                "Deployed system on Hostinger cPanel shared hosting, minimizing costs and simplifying maintenance for school staff.",


            ]
        }, {
            timeline: "2019 - 2019",
            type: "Work",
            heading: "Web Development Intern ",
            location: "Nibodh, Mumbai, India",
            summary: [
                "Initiated and designed a centralized college website, optimizing admissions and payment processes for a 40% increase in online admissions and a 60% improve in payment processing efficiency.",
                "Also Improved Accessibility and Efficiency Showcased strong problem-solving, analytical, project management, engagement, and teamwork skills, contributing to a 20% increase in project efficiency.",
                "Acknowledged for efficient time coordination, adaptability, and rapid learning.",
                "Implemented SEO strategies, resulting in a 25% increase in organic traffic, and ensured responsive design for cross-browser compatibility, enhancing user experience. And Applied Responsive Design, Elevating Website Accessibility Across Various Platforms."
            ]
        }, {
            timeline: "2017 - 2020",
            type: "School",
            heading: " Diploma in Computer Engineering",
            location: "Thakur Polytechnic, Mumbai, India",
            summary: [
                "Through my Diploma in Computer Engineering at Thakur Polytechnic, Mumbai, India, I have acquired a diverse skill set encompassing various facets of computer science.",
                "The coursework included hands-on training in web-based application development using PHP, mobile application development, and programming with Python.",
                "Additionally, I gained expertise in network and information security, advanced database management systems, and advanced Java programming.",
                "Moreover, I honed my skills in software engineering principles, Java programming, and GUI application development using VB.net. ",
                "This comprehensive education has equipped me with the necessary tools to excel in the dynamic field of computer engineering and to contribute effectively to technological innovation."

            ]
        }
    ]
    return (
        <section id="experience" ref={sectionRef} className={`p-5 md:p-16 lg:p-20 rounded-2xl ` + styles.experience}>
            <h2 className={`px-5 md:px-0 main_color ${styles.typing}`}>
                {typedText}
            </h2>
            <Timeline position={matches ? 'alternate' : 'left'}>
                {experienceData.map((item, index) => {
                    return (
                        <TimelineItem key={index} className={styles.timeline_item}
                            sx={matches ? {
                                [`& .${timelineContentClasses.root}:before`]: {
                                    flex: 0.2,
                                },
                            } : {}}
                        >
                            {matches ? <TimelineOppositeContent
                                color="text.secondary">
                                <h6>
                                    {item.timeline}
                                </h6>
                            </TimelineOppositeContent> :
                                <></>}

                            <TimelineSeparator>
                                <span className={styles.experience_icon}>
                                    {item.type === "School" ? <GraduationIcon /> : <WorkIcon />}
                                </span>
                                <TimelineConnector />
                            </TimelineSeparator>
                            <TimelineContent>
                                <ExperienceCard experience={item} index={index} />
                            </TimelineContent>
                        </TimelineItem>
                    )
                })}
            </Timeline>
        </section>
    )
}

export default Experience